/* =========================================
   MUBLIG Mobile Product Back Navigation
   Datei: assets/mublig-mobile-product-nav.js
   ========================================= */

(function () {
  if (window.__mubligMobileProductNavLoaded) return;
  window.__mubligMobileProductNavLoaded = true;

  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function getSameShopReferrer() {
    if (!document.referrer) return null;

    try {
      var referrerUrl = new URL(document.referrer);
      var currentUrl = new URL(window.location.href);

      if (referrerUrl.origin !== currentUrl.origin) return null;
      if (referrerUrl.pathname === currentUrl.pathname) return null;

      return referrerUrl;
    } catch (error) {
      return null;
    }
  }

  function updateBackSubtext() {
    var subtext = document.querySelector('[data-mublig-product-back-subtext]');
    var referrerUrl = getSameShopReferrer();

    if (!subtext) return;

    if (referrerUrl && referrerUrl.pathname.indexOf('/collections/') === 0) {
      subtext.textContent = 'Zurück zur Kategorie';
      return;
    }

    if (referrerUrl) {
      subtext.textContent = 'Zurück zur vorherigen Seite';
      return;
    }

    subtext.textContent = 'Weiter einkaufen';
  }

  function bindBackButton() {
    document.addEventListener('click', function (event) {
      var backLink = event.target.closest('[data-mublig-product-back]');

      if (!backLink || !isMobile()) return;

      var referrerUrl = getSameShopReferrer();

      if (referrerUrl && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateBackSubtext();
      bindBackButton();
    });
  } else {
    updateBackSubtext();
    bindBackButton();
  }
})();